let preventionCount = 0

export default {
    inserted(el, { value }) {
        if (value) {
            addPrevention()
        }
    },

    unbind(el, { value }) {
        if (value) {
            removePrevention()
        }
    },

    update(el, { value, oldValue }) {
        if (value && !oldValue) {
            addPrevention()
        } else if (!value && oldValue) {
            removePrevention()
        }
    }
}

function addPrevention() {
    preventionCount++

    if (preventionCount === 1) {
        document.body.classList.add("overflow-hidden");
    }
}

function removePrevention() {
    preventionCount--

    if (preventionCount === 0) {
        document.body.classList.remove("overflow-hidden");
    }
}
